import {filter, find} from '../../lib/objectHelper';

export const getLabwareDataById = (labwareId) => (state) =>
  find(state.labwareState, (lab) => labwareId && lab.LabwareID === labwareId);

export const getLabwareDataByIds = (labwareIds) => (state) => filter(state.labwareState, {LabwareID: labwareIds});

export const getLabwareState = (state) => state.labwareState;
